// api/axios-interceptors.js
import axios from 'axios';
import { ShowErrorNotification } from '@/utils/request/error-handler';
export const setupAxiosInterceptors = () => {
    const instance = axios.create({
        baseURL: '',
        timeout: 50000
    });
    // 请求拦截器
    instance.interceptors.request.use(
        (config) => {
            // 这里可以添加认证头
            return config;
        },
        (error) => {
            console.error('请求错误:', error);
            ShowErrorNotification({
                title: '请求错误',
                message: '发送请求时发生错误，请检查网络连接。',
                details: error.message
            });
            return Promise.reject(error);
        }
    );
    // 响应拦截器
    instance.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            // console.error('响应错误:', error);
            if (error.response) {
                // 服务器返回了错误状态码
                const { status, data, config } = error.response;
                if (status === 401) {
                    const requestUrl = config?.url || '';
                    if (requestUrl.includes('/api/v1/validate_user')) {
                        return Promise.reject(error);
                    }
                    // 未授权，跳转到登录页
                    window.location.href = "/#/login";
                    return Promise.reject(error);
                }
                let title, message;
                switch (status) {
                    case 400:
                        title = "请求错误";
                        message = data.message || "无效的请求参数";
                        break;
                    case 403:
                        title = "权限不足";
                        message = data.message || "您没有权限执行此操作";
                        break;
                    case 404:
                        title = "资源不存在";
                        message = data.message || "请求的资源不存在";
                        break;
                    case 500:
                        // 区分系统错误和业务错误
                        if (data.message && data.message.includes("业务异常相关标识")) {
                            title = "业务异常";
                            message = data.message;
                        } else if (data.message && data.message.includes("参数异常相关标识")) {
                            title = "参数异常";
                            message = data.message;
                        } else {
                            title = "系统异常";
                            if (data.message !== '') {
                                message = data.message;
                            }else {
                                message = "服务器内部错误，请联系管理员";
                            }
                        }
                        break;
                    default:
                        title = "未知错误";
                        message = `服务器返回错误: ${status}`;
                }
                ShowErrorNotification({ title, message });
            } else if (error.code === 'ERR_NETWORK') {
                // 网络错误
                ShowErrorNotification({
                    title: '网络连接失败',
                    message: '无法连接到服务器，请检查您的网络连接!'
                });
            } else if (error.code === 'ERR_INVALID_TOKEN') {
                ShowErrorNotification({
                    title: '登录过期',
                    message: '您的登录已经过期，请重新登录!'
                });
            }
            // else if (error.code === 'ERR_BAD_RESPONSE'){
            //     // ShowErrorNotification({
            //     //     title: '错误请求',
            //     //     message: '您的接口请求参数出现问题,请刷新重试!'
            //     // });
            //     return Promise.reject(error); // 直接返回错误，不提示
            // }
            else {
                // 其他错误
                ShowErrorNotification({
                    title: '操作失败',
                    message: '发生了一个未知错误，请刷新页面重试。',
                    details: error.message
                });
            }
            return Promise.reject(error);
        }
    );
    return instance;
};
